<template>
  <section ref="raiz" class="lluvia-sobres">
    <div class="contenido">
      <h2 ref="tituloRef" class="titulo">
        <span class="serif"></span><br />
        <span class="script"></span>
      </h2>

      <p ref="textoRef" class="texto">
Lo mejor para mí sería compartir este día contigo✨, 
cualquier otro detalle será muy bien recibido con mucho cariño y agradecimiento,
 que Dios les recompense con muchas bendiciones.  <br> Tambien tendremos la opción lluvia de sobres.
 </p>

      <img ref="sobreRef" :src="sobrePng" alt="Sobre" class="icono-sobre" />

      <p ref="graciasRef" class="gracias">Muchas gracias por su cariño.</p>

      <!-- Línea divisoasasdasdasdadssadria -->
      <hr ref="lineaRef" class="divisor" />

      <!-- Sección Sí Niños --><br>
      <h3 ref="ninosTituloRef" class="ninos-titulo">¡Sí Niños!</h3>

      <p ref="ninosTextoRef" class="ninos-texto">
        Con alegría les damos la bienvenida también a sus pequeños. Para que la fiesta sea un éxito, les pedimos mantenerlos siempre cerca de ustedes durante la presentación.
      </p>
    </div>

    <div ref="lluviaIzq" class="lluvia lluvia-izq" aria-hidden="true"></div>
    <div ref="lluviaDer" class="lluvia lluvia-der" aria-hidden="true"></div>
  </section>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import sobrePng from '@/assets/ss.png' // ✅ una sola importación segura

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'LluviaDeSobres',
  setup() {
    const raiz = ref(null)
    const florRef = ref(null)       // opcional (no está en el template)
    const tituloRef = ref(null)
    const textoRef = ref(null)
    const sobreRef = ref(null)
    const graciasRef = ref(null)
    const lineaRef = ref(null)
    const ninosTituloRef = ref(null)
    const ninosTextoRef = ref(null)
    const lluviaIzq = ref(null)
    const lluviaDer = ref(null)

    // IDs para limpiar setTimeout si se desmonta
    let toDer = null
    let toIzq = null
    let stInstance = null

    // ✅ Crea una "lluvia" de sobres desde un lado (con guardas)
    const crearLluvia = (contenedorEl, lado = 'der', cantidad = 10) => {
      if (!contenedorEl) return
      for (let i = 0; i < cantidad; i++) {
        const el = document.createElement('img')
        el.src = sobrePng
        el.alt = ''
        el.className = 'sobre-lluvia'

        // Si por alguna razón el contenedor dejó de existir, salimos
        if (!contenedorEl.appendChild) return
        contenedorEl.appendChild(el)

        const rndDelay = gsap.utils.random(0, 0.5)
        const rndDur = gsap.utils.random(1.8, 2.6)
        const rndScale = gsap.utils.random(0.35, 0.7)
        const rndRot = gsap.utils.random(-25, 25)
        const xStart = lado === 'der' ? 110 : -10
        const xEnd   = lado === 'der' ? -20 : 120
        const yStart = gsap.utils.random(-20, 20)
        const yEnd   = gsap.utils.random(120, 140)

        gsap.fromTo(
          el,
          { xPercent: xStart, yPercent: yStart, rotate: rndRot, scale: rndScale, opacity: 0 },
          {
            xPercent: xEnd,
            yPercent: yEnd,
            rotate: rndRot + gsap.utils.random(-60, 60),
            opacity: 0.9,
            duration: rndDur,
            ease: 'power2.out',
            delay: rndDelay,
            onComplete: () => el.remove()
          }
        )
      }
    }

    onMounted(async () => {
      await nextTick()

      // ✅ ScrollTrigger seguro + guardas en querySelector
      stInstance = ScrollTrigger.create({
        trigger: raiz.value,
        start: 'top 85%',
        once: true,
        onEnter: () => {
          const tl = gsap.timeline({ defaults: { ease: 'power3.out' } })

          if (florRef.value) {
            tl.fromTo(
              florRef.value,
              { y: -28, opacity: 0, rotate: -6, filter: 'blur(4px)' },
              { y: 0, opacity: 0.9, rotate: 0, filter: 'blur(0px)', duration: 0.45 }
            )
          }

          const serifEl  = tituloRef.value?.querySelector('.serif')
          const scriptEl = tituloRef.value?.querySelector('.script')

          if (serifEl) {
            tl.fromTo(
              serifEl,
              { opacity: 0, y: -24, filter: 'blur(6px)', letterSpacing: '0.03em' },
              { opacity: 1, y: 0, filter: 'blur(0)', letterSpacing: '0em', duration: 0.5 }
            )
          }

          if (scriptEl) {
            tl.fromTo(
              scriptEl,
              { opacity: 0, y: 18, filter: 'blur(5px)' },
              { opacity: 1, y: 0, filter: 'blur(0)', duration: 0.45 },
              '-=0.2'
            )
          }

          if (textoRef.value) {
            tl.fromTo(
              textoRef.value,
              { opacity: 0, y: 14, filter: 'blur(3px)' },
              { opacity: 1, y: 0, filter: 'blur(0)', duration: 0.4 },
              '-=0.05'
            )
          }

          if (sobreRef.value) {
            tl.fromTo(
              sobreRef.value,
              { opacity: 0, y: -80, rotate: 0.001, scale: 0.9, filter: 'blur(0px)' },
              { opacity: 1, y: 0, scale: 1, duration: 0.55, ease: 'back.out(1.6)' },
              '-=0.05'
            )
          }

          if (graciasRef.value) {
            tl.fromTo(graciasRef.value, { opacity: 0, y: 10 }, { opacity: 1, y: 0, duration: 0.35 }, '-=0.1')
          }

          if (lineaRef.value) {
            tl.fromTo(
              lineaRef.value,
              { scaleX: 0, opacity: 0 },
              { scaleX: 1, opacity: 0.7, duration: 0.45, ease: 'power2.out' },
              '-=0.05'
            )
          }

          if (ninosTituloRef.value) {
            tl.fromTo(
              ninosTituloRef.value,
              { opacity: 0, y: 16, filter: 'blur(4px)' },
              { opacity: 1, y: 0, filter: 'blur(0)', duration: 0.45 },
              '-=0.1'
            )
          }

          if (ninosTextoRef.value) {
            tl.fromTo(
              ninosTextoRef.value,
              { opacity: 0, y: 14, filter: 'blur(3px)' },
              { opacity: 1, y: 0, filter: 'blur(0)', duration: 0.4 },
              '-=0.05'
            )
          }

          // ✅ Disparos protegidos contra refs nulas
          toDer = setTimeout(() => crearLluvia(lluviaDer.value, 'der', 12), 80)
          toIzq = setTimeout(() => crearLluvia(lluviaIzq.value, 'izq', 12), 220)
        }
      })
    })

    onUnmounted(() => {
      if (toDer) clearTimeout(toDer)
      if (toIzq) clearTimeout(toIzq)
      if (stInstance) stInstance.kill()
      ScrollTrigger.refresh()
    })

    return {
      raiz,
      florRef,
      tituloRef,
      textoRef,
      sobreRef,
      graciasRef,
      lineaRef,
      ninosTituloRef,
      ninosTextoRef,
      lluviaIzq,
      lluviaDer,
      sobrePng
    }
  }
}
</script>

<style scoped>
.lluvia-sobres{
  position: relative;
  max-width: 520px;
  margin: 0 auto;
  padding: 48px 20px 56px;
  text-align: center;
  background: #efb6c8;
  overflow: hidden;
}
.contenido{ position: relative; z-index: 2;  margin-top:-70px;}

.titulo{
  margin: 0 0 10px;
  color: #fff;
  line-height: 1.05;
}
.titulo .serif{
  font-family: 'britishgruesa', serif;
  font-size: 56px;
  display: inline-block;
}
.titulo .script{
  font-family: 'nombre', cursive;
  font-size: 44px;
  font-weight: 400;
  display: inline-block;
  opacity: .95;
}

.texto{
  font-family: 'quote', serif;
  color: #fff;
  font-size: 17px;
  line-height: 1.5;
  max-width: 420px;
  margin-top:-50px;
  margin: 12px auto 18px;
  opacity: .95;
}

.icono-sobre{
  width: 110px;
  height: auto;
  display: block;
  margin: 8px auto 8px;
  filter: drop-shadow(0 6px 12px rgba(0,0,0,.12));
}

.gracias{
  font-family: 'padres', serif;
  font-size: 17px;
  color: #ffffff;
  letter-spacing: .08em;
  font-weight: 800;
  margin: 4px 0 0;
}

.divisor {
  width: 60px;
  height: 1px;
  background-color: #ffffff;
  border: none;
  margin: 28px auto 20px;
  opacity: 0.7;
}

.ninos-titulo {
  font-family: 'britishgruesa', cursive;
  font-size: 46px !important;
  color: #ffffff;
  font-weight: 400;
  margin: 0 0 8px;
}

.ninos-texto {
  font-family: 'quote', serif;
  color: #ffffff;
  font-size: 17px !important;
  font-style: italic;
  line-height: 1.5;
  max-width: 420px;
  margin: 0 auto;
  opacity: 0.95;
}

.lluvia{
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 1;
}
.lluvia-izq{ left: 0; }
.lluvia-der{ right: 0; }

.sobre-lluvia{
  position: absolute;
  top: -10%;
  left: 0;
  width: 28px;
  height: auto;
  opacity: 0.9;
  filter: drop-shadow(0 4px 8px rgba(0,0,0,.10));
}

@media (max-width: 380px){
  .titulo .serif{ font-size: 50px; }
  .titulo .script{ font-size: 40px; }
  .icono-sobre{ width: 96px; }
  .ninos-titulo { font-size: 36px; }
}
</style>